import { useEffect, useState } from "react";
import axios from "axios";
import { Save, Phone, Mail, Send } from "lucide-react";
import { API } from "../lib/apiClient";

export function SignatureEditor({ prefs, savingPrefs, onSave }) {
  const sig = prefs?.signature || {};
  const [form, setForm] = useState({ name: "", title: "", phone: "", email: "" });
  useEffect(() => {
    setForm({ name: sig.name || "", title: sig.title || "", phone: sig.phone || "", email: sig.email || "" });
  }, [sig.name, sig.title, sig.phone, sig.email]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = () => onSave({ signatureName: form.name, signatureTitle: form.title, signaturePhone: form.phone, signatureEmail: form.email });
  const [testing, setTesting] = useState(false);
  const [testMsg, setTestMsg] = useState("");
  const sendTest = async () => {
    setTesting(true); setTestMsg("");
    try {
      const { data } = await axios.post(`${API}/user/test-email`);
      setTestMsg(`Deneme e-postası ${data.to} adresine gönderildi. Gelen kutunuzu (ve spam klasörünü) kontrol edin.`);
    } catch (e) {
      setTestMsg(`Gönderilemedi: ${e?.response?.data?.detail || e?.message}`);
    } finally {
      setTesting(false);
    }
  };
  const dirty = form.name !== (sig.name || "") || form.title !== (sig.title || "") || form.phone !== (sig.phone || "") || form.email !== (sig.email || "");
  const logo = prefs?.logoUrl || "/brand/logo-mark.png";

  return (
    <div className="signature-editor" data-testid="signature-editor">
      <label className="prefs-row" style={{ gap: 8 }}>
        <input type="checkbox" checked={!!sig.enabled} disabled={savingPrefs} data-testid="pref-signature-enabled"
          onChange={(e) => onSave({ signatureEnabled: e.target.checked })} />
        <span>Tüm e-postaların altına imza ekle</span>
      </label>
      <div className="signature-grid">
        <input className="signature-input" placeholder="Ad Soyad" value={form.name} onChange={set("name")} data-testid="pref-signature-name" />
        <input className="signature-input" placeholder="Unvan (ör. Sigorta Danışmanı)" value={form.title} onChange={set("title")} data-testid="pref-signature-title" />
        <input className="signature-input" placeholder="Telefon (ör. 0555 123 45 67)" value={form.phone} onChange={set("phone")} data-testid="pref-signature-phone" />
        <input className="signature-input" placeholder="E-posta" value={form.email} onChange={set("email")} data-testid="pref-signature-email" />
      </div>
      <div className="signature-preview" data-testid="signature-preview">
        <img src={logo} alt="Logo" onError={(e) => { e.currentTarget.src = "/brand/logo-mark.png"; }} />
        <div>
          <strong data-testid="signature-preview-name">{form.name || "Ad Soyad"}</strong>
          {form.title && <span className="signature-title">{form.title}</span>}
          {form.phone && <span className="signature-line"><Phone size={11} /> {form.phone}</span>}
          {form.email && <span className="signature-line"><Mail size={11} /> {form.email}</span>}
          <small>SİGORTACRM · DAHA GÜÇLÜ İLİŞKİLER</small>
        </div>
      </div>
      <div className="signature-actions">
        <button type="button" className="primary-button small" onClick={save} disabled={savingPrefs} data-testid="pref-signature-save">
          <Save size={13} /> İmzayı kaydet
        </button>
        <button type="button" className="outline-button" onClick={sendTest} disabled={testing || savingPrefs || dirty} data-testid="pref-signature-test-email"
          title={dirty ? "Önce imzayı kaydedin" : ""}>
          <Send size={13} /> {testing ? "Gönderiliyor…" : "Bana deneme e-postası gönder"}
        </button>
      </div>
      {dirty && <small className="signature-hint" data-testid="signature-unsaved-hint">Deneme göndermeden önce değişiklikleri kaydedin.</small>}
      {testMsg && <small className="signature-hint" data-testid="signature-test-msg">{testMsg}</small>}
    </div>
  );
}
